import { debounce } from 'lodash';

export default class WosResizeObserver {
  observer: ResizeObserver;

  observe(fn: ResizeObserverCallback, el: HTMLElement) {
    this.observer = new window.ResizeObserver(debounce(fn, 150));
    this.observer.observe(el);
  }

  disconnect() {
    this.observer.disconnect();
  }
}
